import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import { allKegiatanSosialKey } from "../../queries/KegiatanSosial/useFetchAllKegiatanSosial";
import getQueryClient from "../../queryClient";

export async function removeKegiatanSosial(KEGIATAN_SOSIAL_ID: number) {
  const res = await ApiClient.delete(
    `/RemoveKegiatanSosial?KEGIATAN_SOSIAL_ID=${KEGIATAN_SOSIAL_ID}`
  );
  return res.data[0];
}

export const useRemoveKegiatanSosial = mutationWrapper(removeKegiatanSosial, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allKegiatanSosialKey);
  },
});
